import Select from './select';
import productQtyInputEstimate from './productQtyInputEstimate';
import FormatDollarAmount from './formatDollarAmount';

export default {
    init: function(context){
        var targetContext = context || null,
            showTotalElements = Select.all('[data-show-estimate]', targetContext);
        if(showTotalElements !== null && showTotalElements.length){
            for(var i= 0, len=showTotalElements.length; i < len; i++){
                new productQtyInputEstimate(showTotalElements[i], function(el, estimate){
                    var displayEstimateElement = Select.one('[data-show-estimate-id="' + el.getAttribute('data-show-estimate') + '"]', el.form);
                    if(displayEstimateElement !== null){
                        displayEstimateElement.innerHTML =  estimate > 0 ? '$' + FormatDollarAmount(estimate) : '';
                    }
                });
            }
        }
    }
};
